module.exports = __webpack_public_path__ + "static/img/notice.44437d8c.png";